export default {
    data() {
        return {
            carga_validacion_presentacion: false,
        }
    },

    async created() {
        console.log("validacion_presentacion.created");
    },
    watch: {

    },
    computed: {
        
    },
    methods: {
        
        async mounted() {
            console.log("_/validacion_presentacion.c");
        },
    }
}